module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "sInfo1",
    attrs: {
      "model": _vm.sInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "pguid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "题目id"
    },
    model: {
      value: (_vm.sInfo1.pguid),
      callback: function($$v) {
        _vm.sInfo1.pguid = $$v
      },
      expression: "sInfo1.pguid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题,60字以内"
    },
    model: {
      value: (_vm.sInfo1.title),
      callback: function($$v) {
        _vm.sInfo1.title = $$v
      },
      expression: "sInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原作者GUID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者GUID，需查出来填写，没有时需填0，表示系统提供的解题过程"
    },
    model: {
      value: (_vm.sInfo1.author2Guid),
      callback: function($$v) {
        _vm.sInfo1.author2Guid = $$v
      },
      expression: "sInfo1.author2Guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveSolution
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("解答内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container-jtgc"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar-container-jtgc"
    }
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-font"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-size"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-bold"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-italic"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-underline"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-strike"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-color"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-background"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "sub"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "super"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-blockquote"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-code-block"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "ordered"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "bullet"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "-1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "+1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-direction",
    attrs: {
      "value": "rtl"
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-align"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-link"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-image"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-video"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-formula"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-clean"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "editor-container-jtgc"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1bd775a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solutionDlg/src/main.vue
// module id = 651
// module chunks = 2